<template>
  <!-- O widget do chat será injetado no corpo do documento (body) pelo script,
       então este componente pode ser vazio ou conter um placeholder se necessário. -->
  <div style="display: none;"></div>
</template>

<script>
export default {
  name: 'DigisacChat',
  mounted () {
    // O ID do seu Digisac
    const digisacId = '10d03a8d-ca46-4df8-9503-b681ba95f037'

    // 1. Defina a variável global _digisac com o ID
    window._digisac = {
      id: digisacId
    }

    // 2. Crie o elemento script
    const script = document.createElement('script')
    script.src = 'https://webchat.digisac.app/embedded.js'
    script.async = true // Opcional, mas recomendado para scripts externos

    // 3. Adicione o script ao corpo do documento
    document.body.appendChild(script)
  },
  beforeUnmount () {
    // Opcional: Limpeza ao sair da página (útil se o componente for condicional)
    const scriptUrl = 'https://webchat.digisac.app/embedded.js'
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`)
    if (existingScript) {
      existingScript.remove()
    }
    delete window._digisac
  }
}
</script>
